import { normalizeTextToWords } from '../../picklist/utils';
import { PICKLIST_COMMAND_ALIASES, PICKLIST_COMMAND_WORDS } from '../NvoqQueue/utils/commandUtils';

export type ParsePotentialPicklistCommandResult = {
  bestMatch: string;
  dictatedCommand: string;
  wordIndex: number;
} | null;

export const parsePotentialPicklistCommand = (
  words: string[]
): ParsePotentialPicklistCommandResult => {
  const commandLookup = new Set(
    [...PICKLIST_COMMAND_WORDS, ...PICKLIST_COMMAND_ALIASES].map((value) => value.toLowerCase())
  );

  for (let i = 0; i < words.length; i++) {
    const dictatedCommand = words[i];
    const normalizedWord = normalizeTextToWords(dictatedCommand)[0];
    if (normalizedWord != null && commandLookup.has(normalizedWord)) {
      return { bestMatch: normalizedWord, dictatedCommand, wordIndex: i };
    }
  }
  return null;
};
